import * as angular from 'angular';
import { downgradedComponents } from './downgraded-components/downgraded-components.module';
import { downgradedServicesModule } from './downgraded-services/downgraded-services.module';
import nvSharedStaticModelsModule from './static-models/nv.shared.static-models.module';

namespace nv.shared {
  'use strict';

  angular.module('nv.shared', [
    'nv.shared.modals',
    nvSharedStaticModelsModule,
    'nv.shared.background-job-ui',
    downgradedServicesModule,
    downgradedComponents,
  ]);
}
